import {
  CapacityGranularity,
  capacityGranularity,
} from "./capacityGranularity";
import { CapacitySort } from "./capacitySort";
import { Filter } from "./filter";

type RetrieveOccupancyRequest = {
  from: string;
  to: string;
  granularity: CapacityGranularity;
  page: number;
  size: number;
  filter?: Filter;
  sort?: CapacitySort;
};

const retrieveOccupancyRequest: RetrieveOccupancyRequest = {
  from: "",
  to: "",
  granularity: capacityGranularity,
  page: 0,
  size: 20,
};

export type { RetrieveOccupancyRequest };

export { retrieveOccupancyRequest };
